<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
       <a-form-item label="小组名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'groupName', validatorRules.groupName]" placeholder="请输入小组名称"></a-input>
        </a-form-item>
        <a-form-item label="基地" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['baseId', validatorRules.baseId]" :trigger-change="true" disabled="disabled" dictCode="bus_inspection_base,base,id" placeholder="请选择基地id"/>
        </a-form-item>
        <a-form-item label="部门" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['departId', validatorRules.departId]" :trigger-change="true" disabled="disabled" dictCode="bus_inspection_base_depart,depart,id" placeholder="请选择部门id"/>
        </a-form-item>
        <a-form-item label="车间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['workshopId', validatorRules.workshopId]" :trigger-change="true" disabled="disabled" dictCode="bus_inspection_depart_workshop,workshop,id" placeholder="请选择车间id"/>
        </a-form-item>
        <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="radio" v-decorator="['status', validatorRules.status]" :trigger-change="true" dictCode="depart_status" placeholder="请选择状态"/>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import { checkBusInspectionBaseDepart } from '@/api/api'
  
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"

  export default {
    name: "GroupModal",
    components: { 
      JDictSelectTag,
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          groupName: {rules: [
            {required: true, message: '请输入小组名称!'},
          ]},
          baseId: {rules: [
            {required: true, message: '请输入基地!'},
          ]},
          departId: {rules: [
            {required: true, message: '请输入部门!'},
          ]},
          workshopId: {rules: [
            {required: true, message: '请输入车间!'},
          ]},
          status: {rules: [
            {required: true, message: '请输入状态!'},
          ]},
        },
        url: {
          add: "/workshop/busInspectionWorkshopGroup/add",
          edit: "/workshop/busInspectionWorkshopGroup/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add (record) {
        record.status = 1
        this.edit(record);
      console.log(this.baseOptions)
      console.log(this.departOptions)
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'groupName','baseId','departId','workshopId','status'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'groupName','baseId','departId','workshopId','status'))
      }
      
    }
  }
</script>